import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

// THIS FILE SHOULD BE REFACTORED TO BE USED IN THE OTHER PRECISION GRAPHICS FILES

export const PristineBox = styled(Box)(() => ({
  width: '40px',
  backgroundColor: 'lightgray',
  borderRadius: 4,
  boxShadow: `
          inset 0 0 50px #e0e0e0,      /* inner white */
          inset 20px 0 80px #f0f,   /* inner left magenta short */
          inset -20px 0 80px #0ff,  /* inner right cyan short */
          inset 20px 0 300px #f0f,  /* inner left magenta broad */
          inset -20px 0 300px #0ff, /* inner right cyan broad */
          0 0 10px #e0e0e0,            /* outer white */
          -5px 0 40px #f0f,        /* outer left magenta */
          5px 0 40px #0ff;         /* outer right cyan */`,
}));

export const PristineTypography = styled(Typography)(() => ({
  fontFamily: 'blacksword',
  textAlign: 'center',
  letterSpacing: 8,
  color: 'darkgreen',
  fontWeight: 600,
}));

export const PoisedBox = styled(Box)(() => ({
  width: '40px',
}));

export const PoisedTypography = styled(Typography)(() => ({
  fontFamily: 'barbatrick',
  textAlign: 'center',
  color: 'red',
}));

export const PassableBox = styled(Box)(() => ({
  width: '40px',
  paddingLeft: '1px',
  paddingRight: '1px',
  border: '1px solid',
  borderColor: 'cadetblue',
}));

export const PassableTypography = styled(Typography)(() => ({
  fontFamily: 'round-pixel',
  textAlign: 'center',
  paddingLeft: '1px',
  border: '1px solid',
  borderColor: 'cadetblue',
  color: 'cadetblue',
}));

export const PanickyBox = styled(Box)(() => ({
  width: '40px',
  paddingLeft: '7px',
  paddingRight: '7px',
  border: '1px solid orange',
  borderRadius: 4,
}));

export const PanickyTypography = styled(Typography)(() => ({
  fontFamily: 'schoolbell',
  textAlign: 'center',
}));
